export enum EMasterTabs {
  MasterChats = 'masterChats',
  SubAgentsChats = 'subAgentsChats',
}

export type TMasterFiltersState = {
  activeTab: EMasterTabs;
  selectedSubAgentId?: number;
};
